<script setup lang="ts">
import { onMounted, onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import { useCookies } from 'vue3-cookies';
import { getDomain, getQueryString, getBrowserInfo } from '@/utils/util';

import useAuthStore from '@store/auth';
import useSystemStore from '@store/system';
import useUserStore from '@store/user';

const { t } = useI18n({ useScope: 'global' });
const { cookies } = useCookies();
const authStore = useAuthStore();
const systemStore = useSystemStore();
const userStore = useUserStore();
const { isLoggedIn } = storeToRefs(authStore);

async function init() {
  injectData();
  injectMobileSafariTag();
  await authStore.authState();
  await systemStore.setSystemConfig();
  await userStore.getUserInfo();
}

init();

async function injectData() {
  if (!cookies.get('timeZone')) {
    cookies.set(
      'timeZone',
      Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone,
      30 * 24 * 60 * 60,
      '/',
      getDomain()
    );
  }

  // 邀请需要暂时记住，登录后会删除
  if (getQueryString('invite_code')) {
    localStorage.setItem(
      'invite_code_and_channel',
      `${getQueryString('invite_code')}__${getQueryString('ch')}`
    );
  }

  setVhUnit();
}

async function injectMobileSafariTag() {
  const browserInfo = getBrowserInfo();
  if (browserInfo.isSafari && browserInfo.isMobile) {
    document.body.setAttribute('data-safari', 'true');
  }
}

function setVhUnit() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function isMobile() {
  if (window.innerWidth <= 820) {
    systemStore.isMobileWeb = true;
  } else {
    systemStore.isMobileWeb = false;
  }
}

function disableDebugger() {
  const obj = Object.create(null);
  // 记录当前时间
  let t = Date.now();
  //监听对象属性的获取

  Object.defineProperty(obj, 'is_debug', {
    // eslint-disable-next-line getter-return
    get: () => {
      // 当对象属性的取值方法被触发时，判断时间间隔是否大于50ms,替换为空白页
      if (Date.now() - t > 50) {
        location.replace('about:blank');
      }
    },
  });

  // 定时打印is_debug触发属性的get方法进行判断
  setInterval(() => {
    // 记录开始debugger时间
    t = Date.now();

    (function debug() {
      // @ts-ignore
    })['constructor']('debugger')();
    // 触发obj.is_debug的get方法
    console.log(obj.is_debug);
  }, 100);
}

function onDebug() {
  if (
    getQueryString('is_debug') !== '1' &&
    location.host.includes('visionstory.ai')
  ) {
    // @ts-ignore
    document.oncontextmenu = new Function('event.returnValue=false');
    // 2.禁止键盘F12键
    document.addEventListener('keydown', function (e) {
      if (e.key == 'F12') {
        e.preventDefault();
      }
    });

    disableDebugger();
  }
}

onBeforeMount(() => {
  isMobile();
});

onMounted(async () => {
  window.addEventListener('resize', () => {
    isMobile();
  });

  // onDebug();
});
</script>

<template>
  <router-view />
</template>

<style lang="scss">
@use '@css/init' as *;
</style>
